import React from "react";

type Props = {
  title: string;
};

const Title: React.FC<Props> = ({ title }): JSX.Element => {
  return (
    <div className="flex flex-row items-center justify-center mb-5">
      <div
        className="font-nunito text-xl"
        style={{
          fontStyle: "normal",
          fontWeight: 300,
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default Title;
